import {DateTime} from 'luxon';
import {Box} from '../../../../styled';
import { ReactComponent as TimeLight } from '../../../../../images/time-light.svg';
import React from 'react';

interface JiraDueDateProps{
  date: string
}
const JiraDueDate = ({ date }: JiraDueDateProps) => {
  if (!date) {
    return null;
  }
  const pDate = DateTime.fromISO(date);
  const isAfter = pDate < DateTime.now();

  return (
    <Box
      display={'inline-flex'}
      alignItems={'center'}
      justifyItems={'space-around'}
      p={1}
      bg={isAfter ? 'rgba(243, 165, 165, 0.37)' : '#fff'}
      color={isAfter ? 'rgba(175, 1, 1, 1)' : 'inherit'}
    >
      <TimeLight />
      {pDate.toLocaleString(DateTime.DATE_MED)}
    </Box>
  )
}

export default JiraDueDate;